import { useCallback, useState } from 'react';

type CallbackFunction = () => void;

interface MultipleReingestState {
  showReingestModal: boolean;
  isMultipleReingestActive: boolean;
  resetMultipleReingestFile: (callback?: CallbackFunction) => void;
  openReingestModal: () => void;
  onCloseReingestModal: () => void;
  enableMultipleReingestFile: () => void;
}

export const useMultipleReingestState = (): MultipleReingestState => {
  const [showReingestModal, setShowReingestModal] = useState(false);
  const [isMultipleReingestActive, setMultipleReingestActive] = useState(false);

  const resetMultipleReingestFile = useCallback((callback?: CallbackFunction) => {
    setMultipleReingestActive(false);
    callback?.();
  }, []);

  const enableMultipleReingestFile = () => setMultipleReingestActive(true);

  const openReingestModal = () => setShowReingestModal(true);

  const onCloseReingestModal = () => setShowReingestModal(false);

  return {
    showReingestModal,
    isMultipleReingestActive,
    resetMultipleReingestFile,
    openReingestModal,
    onCloseReingestModal,
    enableMultipleReingestFile,
  };
};
